
/* eslint-disable */
import GridItem from '@/components/GridItem.vue'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
// import { debounce } from 'vue-debounce'

export default {
  name: 'Lieux',
  components: {
    GridItem,
    Multiselect
  },
  head() {
    return {
      title: this.$t('venue_search.metaTitle'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('venue_search.metaDescription') },
        { hid: 'og:title', name: 'og:title', content: this.$t('venue_search.metaTitle') },
        { hid: 'og:description', name: 'og:description', content: this.$t('venue_search.metaDescription') },
        { hid: 'og:image', name: 'og:image', content: '~assets/img/showroom-fashionweek-bg.png' },
        { hid: 'og:url', name: 'og:url', content: process.env.NUXT_ENV_LOCAL_URL + '/lieux/' }
      ],
      script: [{ type: 'application/ld+json', json: this.structuredData }]
    }
  },
  data() {
    return {
      snackbar: false,
      loadMore: true,
      someSallesLoaded: false,
      page: 1,
      salles: [],
      allSalles: [],
      empty: false,
      searchError: false,
      meta_search: null,
      area_ranges: [null, null],
      categories: [],
      postalCodeOptions: [],
      postal_code: [],
      type: ["Showroom"],
      quartier: [],
      // equipements: ['Béton Ciré', 'Parquet', 'Espace Extérieur (jardin, terrasse, balcon)', 'Vitrine sur rue', 'De plain-pied', 'Coin Cuisine', 'Verrière', 'Hébergement sur place', 'Air conditionné'],
      checkedEquipment: []
    }
  },
  watch: {
    area_ranges: {
      async handler() {
        await this.search()
      },
      deep: true
    },
    async postal_code() {
      await this.search()
    },
    async checkedEquipment() {
      await this.search()
    },
    async type() {
      await this.search()
    },
    async quartier() {
      await this.search()
    },
    async categories() {
      await this.search()
    },
    async '$i18n.locale'() {
      await this.search()
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'user/loggedIn',
      favoriteSallesSize: 'salles/favoriteSallesSize',
      lastSalleFromLieuxList : 'salles/lastSalleFromLieuxList'
    }),
    postal_codeValues: {
    	get () {
        let options = this.postalCodeOptions.map((el) => ({
          label: this.$t(`venue_search.arrondissement['${el}']`) || el,
          value: el
        }))
        return options.filter(
          option => this.postal_code.includes(option.value)
        )
      },
      set (newSelectedOptions) {
   			this.postal_code = newSelectedOptions.map(option => option.value)
      }
    },
    typeValues: {
    	get () {
        let options = this.typeOptions.map((el) => ({
          label: this.$t(`venue_search.event_types['${el}']`) || el,
          value: el
        }))
        return options.filter(
          option => this.type.includes(option.value)
        )
      },
      set (newSelectedOptions) {
   			this.type = newSelectedOptions.map(option => option.value)
      }
    },
    categoriesValues: {
    	get () {
        return this.categoriesOptions.filter(
          option => this.categories.includes(option.value)
        )
      },
      set (newSelectedOptions) {
   			this.categories = newSelectedOptions.map(option => option.value)
      }
    },
    equipementsValues: {
    	get () {
        return this.equipementsOptions.filter(
          option => this.checkedEquipment.includes(option.value)
        )
      },
      set (newSelectedOptions) {
   			this.checkedEquipment = newSelectedOptions.map(option => option.value)
      }
    },
    // define these options as computed to allow dynamic modification regarding the locale
    equipementsOptions() {
      return [
        {
          value: 'Béton Ciré',
          label: this.$t('venue_search.waxed_concrete')
        },
        {
          value: 'Espace Extérieur (jardin, terrasse, balcon)',
          label: this.$t('venue_search.outside')
        },
        {
          value: 'Parquet',
          label: this.$t('venue_search.wooden_floor')
        },
        {
          value: 'Vitrine sur rue',
          label: this.$t('venue_search.street_shop')
        },
        {
          value: 'De plain-pied',
          label: this.$t('venue_search.single_storey')
        },
        {
          value: 'Coin Cuisine',
          label: this.$t('venue_search.kitchenette')
        },
        {
          value: 'Verrière',
          label: this.$t('venue_search.canopy')
        },
        {
          value: 'Hébergement sur place',
          label: this.$t('venue_search.accommodation')
        },
        {
          value: 'Air conditionné',
          label: this.$t('venue_search.ac')
        },
        {
          value: 'Alarme',
          label: this.$t('venue_search.alarm')
        },
        {
          value: 'Sonorisation',
          label: this.$t('venue_search.sono')
        },
        {
          value: 'Restauration intégrée',
          label: this.$t('venue_search.catering_on_site')
        },
        {
          value: 'Mobilier',
          label: this.$t('venue_search.furniture')
        },
        /*{
          value: 'Machine à café',
          label: this.$t('venue_search.coffeeMachine')
        },{
          value: 'Micro-onde',
          label: this.$t('venue_search.microwave')
        },
        {
          value: 'Tableau blanc',
          label: this.$t('venue_search.paperboard')
        },
        {
          value: 'Vidéo-projecteur',
          label: this.$t('venue_search.videoprojector')
        },*/
        {
          value: 'Système de visioconférence',
          label: this.$t('venue_search.videoconferencing')
        },
        /*{
          value: 'Accès handicapé',
          label: this.$t('venue_search.accesHandicape')
        }*/
      ]
    },
    categoriesOptions() {
      return [
        {
          label: this.$t('venue_search.venue_types.appartement'),
          value: "Appartements / Haussmanniens"
        },
				{
          label: this.$t('venue_search.venue_types.galery'),
          value: "Loft / Atelier / Galerie"
        },
				{
          label: this.$t('venue_search.venue_types.hotels'),
          value: "Hôtels particuliers / Espaces historiques"
        },
				{
          label: this.$t('venue_search.venue_types.autre'),
          value: "Autre"
        }
      ]
    }
  },
  async asyncData({ store, $axios, $i18n, app }) {
    try {
      store.dispatch('loading/start')
      const postalCodeOptions = await $axios.$get(
        process.env.NUXT_ENV_API_URL + '/salles/cp'
      )
      // const categoriesOptions = await $axios.$get(
      //   process.env.NUXT_ENV_API_URL + '/salles/categories'
      // )
      const types = await $axios.$get(
        process.env.NUXT_ENV_API_URL + '/salles/types'
      )
      const quartierOptions = await $axios.$get(
        process.env.NUXT_ENV_API_URL + '/salles/quartiers'
      )
      const { superficie } = await $axios.$get(
        process.env.NUXT_ENV_API_URL + '/salles/pricearearange'
      )
      const sallesIds = await $axios.$get(
        process.env.NUXT_ENV_API_URL + '/salles/published'
      )

      store.dispatch('loading/end')
      const structuredData = { // from https://schema.org/SearchResultsPage
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Showroom rental for Paris Fashionweek",
        "provider": {
          "@type": "LocalBusiness",
          "name": "Showroom Fashionweek"
        },
        "areaServed": {
          "@type": "City",
          "name": "Paris"
        },
        "specialty": "Vous souhaitez louer un showroom pour la Fashion Week à Paris ? Confiez votre recherche à nos spécialistes de la mode à Paris depuis plus de 15 ans.",
        "url": process.env.NUXT_ENV_LOCAL_URL + '/lieux/',
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Showroom leasing",
          "itemListElement": []
        }
      }
      for(let salle of sallesIds){
        let images = []
        if(salle.documents)
          for(let doc of salle.documents){
            images.push(process.env.NUXT_ENV_API_URL + doc.path)
          }
        structuredData.hasOfferCatalog.itemListElement.push({
          "@type": "Offer",
          "itemOffered": {
            "@type": "Accommodation",
            "name": salle.denominationEE,
            "url":  process.env.NUXT_ENV_API_URL + '/lieu/' + salle.slug.toLowerCase()
          }
        })
      }
      return {
        postalCodeOptions: postalCodeOptions.filter((el) => !!el).sort(),
        typeOptions: types.filter((el) => !!el),
        quartierOptions: quartierOptions.filter((el) => !!el).sort(),
        superficieMax: superficie || 100,
        sallesIds,
        structuredData
      }
    } catch (error) {
      if (error && error.response && error.response.status === 404) {
        store.dispatch('loading/end')
        return { showLieux: true, searchError: true }
      }
    }
  },
  async mounted() {
    try{
      this.snackbar = true
      await this.infiniteHandler()
      if(this.snackbar) await this.closeAfterTimeOut()
    } catch (e) {
      console.error(e)
    }

  },
  methods: {
    async search(){
      this.page = 1
      this.salles = []
      this.allSalles = []
      try{
        _.debounce(this.infiniteHandler, 400)()
      } catch(e) {
        console.error(e)
      }
    },
    async infiniteHandler() {
      await this.$store.dispatch('loading/start')
      this.loadMore = false
      const query = {
        meta_search: this.meta_search ? this.meta_search : null,
        categories: this.categories,
        areaRangesMin: this.area_ranges[0] ?? 0,
        areaRangesMax: this.area_ranges[1] ?? this.superficieMax,
        pageNumber: this.page,
        checkedEquipment: this.checkedEquipment
      }

      if (this.postal_code) query.cp = this.postal_code
      if (this.type) query.types = this.type
      if (this.quartier) query.quartiers = this.quartier
      const { pageNumber, ...storeQuery } = query

      try{
        let res = await this.$axios.get(process.env.NUXT_ENV_API_URL + '/salles', { params: query })
        this.page += 1
        let newSalles = res.data.filter(salle => !this.salles.some(s => s._id == salle._id))
        this.salles.push(...newSalles)
        this.empty = this.salles.length === 0
        if(res.data.length >= 20) this.loadMore = true

        let allSallesRes = await this.$axios.get(process.env.NUXT_ENV_API_URL + '/salles', { params: storeQuery }) // request every salles to display them in the html for crawler to see them
        this.allSalles = allSallesRes.data
        this.someSallesLoaded = true
      } catch (e) {
        console.error(e)
        console.log(e)
      }finally {
        await this.$store.dispatch('loading/end')
      }

      // }
    },
    // setAreaAndPriceRange() {
    //   this.area_ranges[1] = this.superficieMax
    // },
    goToLieu(salleIndex) {
      this.$store.dispatch(
        'salles/setSallesSearch',
        this.allSalles.map((el) => {
          return { _id: el._id, slug: el.slug.toLowerCase() }
        })
      )

      this.$store.dispatch(
        'salles/setLastSalleFromLieuxList',
        this.salles[salleIndex]
      )

      this.$router.push(
        this.localePath({
          name: 'lieu-salleSlug',
          params: { salleSlug: this.salles[salleIndex].slug.toLowerCase() }
        })
      )
    },
    addToFavorites(salle) {
      this.closeSnackBar()
      try {
        this.$store.dispatch('salles/addFavoriteSalle', salle)
      } catch (error) {
        console.error(error)
      }
    },
    removeFromFavorites(salleId) {
      try {
        this.$store.dispatch('salles/removeFavoriteSalle', salleId)
      } catch (error) {
        console.error(error)
      }
    },
    async closeAfterTimeOut(){
      // await new Promise(resolve => setTimeout(resolve, 3000)); // 3 sec
      try{
        await this.sleep(10000);
        this.closeSnackBar()
      } catch (error) {
        console.error(error)
      }
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    closeSnackBar(){
      this.snackbar = false
      try {
        this.$store.dispatch('user/setFavorites', false)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
